import { render, staticRenderFns } from "./addGoods.vue?vue&type=template&id=429bcf03&scoped=true&"
import script from "./addGoods.vue?vue&type=script&lang=js&"
export * from "./addGoods.vue?vue&type=script&lang=js&"
import style0 from "./addGoods.vue?vue&type=style&index=0&id=429bcf03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429bcf03",
  null
  
)

export default component.exports